import { render, staticRenderFns } from "./PopupForm.vue?vue&type=template&id=73d2e8b6&scoped=true&"
import script from "./PopupForm.vue?vue&type=script&lang=js&"
export * from "./PopupForm.vue?vue&type=script&lang=js&"
import style0 from "./PopupForm.vue?vue&type=style&index=0&id=73d2e8b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2e8b6",
  null
  
)

export default component.exports